import React from "react";
import ComponentCard from "../../components/common/ComponentCard";
import CourseListComponent from "../../components/course/CourseListComponent";
import PageMeta from "../../components/common/PageMeta";


const CourseList = () => {

    return (
        <>
            <PageMeta title="Danh sách khóa học" description="Trang danh sách khóa học"/>
            <div className="space-y-6">
                <ComponentCard title="">
                    <CourseListComponent />
                </ComponentCard>
            </div>
        </>
    );
};

export default CourseList;
